<template>
  <div class="stepper-container">
    <PVStepper
      :value="currentStep"
      :pt="{
        root: {
          style: {
            width: '95%',
          },
        },
      }"
    >
      <PVStepList
        :pt="{
          root: {
            style: {
              'overflow-x': 'visible',
            },
          },
        }"
      >
        <progress-step-item
          v-for="step in steps"
          :key="step.value"
          :current-stepper-value="currentStep"
          :display-value="step.displayValue"
          :is-completed="isCompleted"
          :is-failed="isFailed"
          :label="step.label"
          :steps="stepsList"
          :value="step.value"
        >
          <template v-if="step.dropdownComponent" #dropdown-content>
            <component
              v-bind="step.dropdownComponent?.props"
              :is="step.dropdownComponent?.component"
              @dropdown-update="handleDropdownUpdate"
            >
            </component>
          </template>
        </progress-step-item>
      </PVStepList>
    </PVStepper>
  </div>
</template>

<script lang="ts" setup generic="T extends object">
  import { ProgressStepsProps } from './ProgressSteps.types';
  import { computed } from 'vue';

  const props = defineProps<ProgressStepsProps<T>>();

  const emit = defineEmits<{
    (e: 'dropdown-update'): void;
  }>();

  const stepsList = computed(() => props.steps.map((step) => step.value));

  function handleDropdownUpdate() {
    emit('dropdown-update');
  }
</script>

<style scoped lang="scss">
  .stepper-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
